var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.forceModifierInteraction && !_vm.modifierGroup.minimumRequired())?_c('ExtraSelector',{attrs:{"extra":_vm.modifierGroup.dummyModifier,"refused-modifier":"","parent":_vm.modifierGroup},on:{"click":_vm.emitClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }